import React from 'react'
import {Navigate} from 'react-router-dom'
import logo from '../../assets/Logo DR Milidou.png'
  
function OnBoardingMildiou() {
  const [goToQ1, setGoToQ1] = React.useState(false)
  const [goToMildiou, setGoToMildiou] = React.useState(false)

  function handleQ1(){
    setGoToQ1(true)
  }
  function handleMildiou(){
    setGoToMildiou(true)
  }


  if(goToMildiou) {
    return <Navigate push to={`/diagoriskMildiou/accueil`}/>
  }
  if(goToQ1) {
    return <Navigate push to={`/diagoriskMildiou/questionnaire1`}/>
  }
  return (
    <div className='containerMildiou'>
      <div className='row' style={{flexDirection:'column'}}>
        <img src={logo} alt="logo DiagoRisk" style={{width:'20%'}}/>
        <div className='titrePlus'> OnBoarding </div>
      </div>
      <div className='paragraphe'> en cours de construction</div>
      <div><button onClick={handleQ1}>Questionnaire 1</button></div>
      <div><button onClick={handleMildiou}>accueil</button></div>
    </div>
  )
}

export default OnBoardingMildiou